import VideoList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageVideo from "../../../../../components/sections/admin/Video/ManageVideo";
import VideoCategory from "../VideoCategory";
import VideoComment from "../VideoComment";
import VideoTags from "../VideoTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-blog",
    path: "/admin/videos",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/video-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/video-tags",
  },
  // {
  //   label: "Comments",
  //   icon: "fa-regular fa-comments",
  //   path: "/admin/video-comments",
  // },
];

export const videoRoutes = () => [
  {
    path: "/admin/videos",
    component: () => (
      <TabsNavigation title="Videos Management" tabRoutes={tabRoutes}>
        <VideoList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Video Management",
  },
  {
    path: "/admin/video-categories",
    component: () => (
      <TabsNavigation title="Videos Management" tabRoutes={tabRoutes}>
        <VideoCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Video Management",
  },
  {
    path: "/admin/video-tags",
    component: () => (
      <TabsNavigation title="Videos Management" tabRoutes={tabRoutes}>
        <VideoTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Video Management",
  },
  // {
  //   path: "/admin/video-comments",
  //   component: () => (
  //     <TabsNavigation title="Videos Management" tabRoutes={tabRoutes}>
  //       <VideoComment />
  //     </TabsNavigation>
  //   ),
  //   layout: "admin",
  //   routeType: "admin",
  //   title: "Video Management",
  // },
  {
    path: "/admin/manage-videos",
    component: ManageVideo,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
  {
    path: `/admin/manage-videos/:id`,
    component: ManageVideo,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
];
